import { useMutation } from "react-query";
import { addOperationsGroup } from "actions/Utilities/OperationsGroup";
import { toast } from "components/toastNotification";
import { IOperationsGroup } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateOperationsGroup,
  operationsGroupReFetching,
} from "../atoms/atoms";

const useAddOperationsGroup = () => {
  const setIsAddState = useSetRecoilState(addStateOperationsGroup);
  const [isReFetching, setIsReFetching] = useRecoilState(
    operationsGroupReFetching
  );

  const { mutate } = useMutation(
    (NewData: IOperationsGroup) => addOperationsGroup(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Operations Group failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Operations Group Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Operations Group Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Operations Group failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Operations Group failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Operations Group failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Operations Group failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddOperationsGroup;
